import React from 'react'
import GoalsStore from '../DataRepo/GoalsStore'
import { useEffect, useState } from 'react'
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import WellnessStore from '../DataRepo/WellnessStore';
import HealthScoreChart from './HealthChart';
import dietcard from '../Assets/images/diet_card.png'
import SupplementCard from '../Assets/images/herbalproducts_card.png'
import RecipesCard from '../Assets/images/recipes_card.png'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import LifeStylePracticesCard from '../Assets/images/Lifestyle practices_card.png'
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function GoalResult() {
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const { Diets, getDiet, isDietLoading } = WellnessStore();
    const { getYoga, selectedYogas, unselectedYogas, isYogaLoading } = WellnessStore();
    const { isMeditationdataLoading, getMedidationData, Meditationdata } = WellnessStore();

    const { getGoal, Goals, isGoalsLoading, error } = GoalsStore();

    const ratings = ["Good", "Mild", "Moderate", "Poor", "Severe", "Extreme"]

    useEffect(() => {
        getGoal();
        getYoga();
        getMedidationData();
    }, []);

 
    useEffect(() => {
        getDiet()
    }, [])

    const groupBy = (array, key) => {
        if (!array) return {};
        return array.reduce((result, currentValue) => {
            const groupKey = currentValue[key];
            if (!result[groupKey]) {
                result[groupKey] = [];
            }
            result[groupKey].push(currentValue);
            return result;
        }, {});
    };

    const DietsSuitable = groupBy(Diets?.Suitable, 'categoryEng');
    const DietsNot_Suitable = groupBy(Diets?.Not_Suitable, 'categoryEng');

    const predefinedOrder = [
        'Cereals & Millets',
        'Fruits',
        'Vegetables',
        'Pulses',
        'Spices',
        'Sugar Products',
        'Milk products',
        'Oil and Fats',
        'General',
        'Alcoholic Beverages'
    ];

    const landingImages = {
        'Cereals & Millets': 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/Cereals+%26+Millets.png',
        'Fruits': 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/Fruits.png',
        'Vegetables': 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/Vegetables.png',
        'Pulses': 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/Pulses.png',
        'Spices': 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/Spices.png',
        'Sugar Products': 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/Sugar+Products.png',
        'Milk products': 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/Milk+Products.png',
        'Oil and Fats': 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/Oil+%26+Fats.png',
        'General': "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/General.png",
        'Alcoholic Beverages': 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/dieticons/Alcoholic+Beverages.png'
    };

    const uniqueCategories = predefinedOrder.filter(category =>
        Object.keys(DietsSuitable).includes(category) || Object.keys(DietsNot_Suitable).includes(category)
    );


    return <div className='m-5 ' style={{ marginBottom: "1rem" }}>
        <div className='Goals-result-page'>

            <div className='Goals-total-container'>
                <HealthScoreChart percentage={Goals?.Total} homepage={false} handleClickOpen={handleClickOpen} />
            </div>

            <div className='Goals-recommendations'>
                <p>Personalized Recommendations</p>

                <div className='Personalizedremcontainer mt-5'>
                    <div className='Personalizedremcard'>
                        <div>
                            <img src={dietcard}></img>
                        </div>
                        <div className='flex items-center justify-between' onClick={() => {
                            navigate('/DietSection')
                        }}>
                            <p>Diet</p>
                            <ArrowRightAltIcon />
                        </div>
                    </div>

                    <div className='Personalizedremcard'>

                        <div>
                            <img src={RecipesCard}></img>
                        </div>

                        <div className='flex items-center justify-between' onClick={() => {
                            navigate('/RecipeSection')
                        }}>
                            <p>Recipes</p>
                            <ArrowRightAltIcon />
                        </div>

                    </div>

                    <div className='Personalizedremcard'>
                        <div>
                            <img src={LifeStylePracticesCard}></img>
                        </div>
                        <div className='flex items-center justify-between' onClick={() => {
                            navigate('/Recipes')
                        }}>
                            <p>Lifestyle Practices</p>
                            <ArrowRightAltIcon />
                        </div>
                    </div>

                    <div className='Personalizedremcard'>
                        <div>
                            <img src={SupplementCard}></img>
                        </div>
                        <div className='flex items-center justify-between' onClick={() => {
                            navigate('/Shop')
                        }}>
                            <p>Herbal Products</p>
                            <ArrowRightAltIcon />
                        </div>
                    </div>

                </div>

                <div className='Tele-consultation-end-section mt-5'>
                    <p>Begin your journey & <br /> achieve your goal
                    </p>
                </div>

                {/*
                {uniqueCategories.length > 0 && <div className='mt-5'>
                    <p>Diet</p>
                    <div className='rmdfoods mt-1'>
                        {uniqueCategories?.map((category, index) => (
                            <div onClick={() => {
                                navigate(`/Diet?categoryname=${category}`)
                            }}>
                                <div >
                                    <img src={landingImages[category]}></img>
                                </div>
                                <div>
                                    <p>{category}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>}

                {
                    selectedYogas.length > 0 &&
                    <div className='mt-5'>
                        <p>Yoga</p>
                        <div>
                            <div className='mt-2 Yogalist-container'>
                                {
                                    selectedYogas.map((e, i) => {
                                        return <div className='yogacard' onClick={() => {
                                            navigate(`/yoga?id=${e?.id}`)
                                        }}>
                                            <div>
                                                <p>{e?.title}</p>
                                                <p>{e?.pose}</p>
                                            </div>
                                            <div>
                                                <img src={e?.image} />
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                        </div>

                    </div>
                }

                <div className='mt-5'>
                    <p>Meditation</p>
                    <div className='Yogalist-container'>

                        {
                            Meditationdata.map((e, i) => {
                                return <div className='Meditation-Card' key={i} onClick={() => {
                                    navigate(`/Meditation?id=${e.Id}`)
                                }}>
                                    <p>{e?.title}</p>
                                    <img src={e?.image}></img>
                                </div>
                            })
                        }

                    </div>

                </div>

                <div>

                </div> */}
            </div>

            <BootstrapDialog
                fullWidth={true}
                maxWidth='sm'
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    <p className='smttitle'>Symptoms & its Severity</p>

                </DialogTitle>

                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent dividers>
                    <div className='flex flex-col gap-5 p-5'>
                        {
                            Goals?.SymptomsList?.map((e, i) => {
                                return <div className="flex items-center justify-between symptoms-severity">
                                    <p className="mr-2">{e?.symptoms}</p>
                                    <div className="flex-1 mx-2" style={{
                                        borderTop: "1px dashed",
                                        borderColor: "gray",
                                        borderWidth: "1px",
                                        borderImage: "none",
                                        borderStyle: "dashed",
                                        borderSpacing: "8px",
                                    }}></div>
                                    <p style={{ color: "#DA6E0B" }}>{ratings[e?.severity]}</p>
                                </div>

                            })
                        }
                    </div>
                </DialogContent>
                
            </BootstrapDialog>

        </div>
    </div>
}

export default GoalResult